export default (data, columns) => {
    if (data.length % columns === 0) return data;

    const rows = Math.floor(data.length / columns);
    let lastRowElements = data.length - rows * columns;

    while (lastRowElements !== columns) {
        data.push({
            empty: true
        });
        lastRowElements += 1;
    }
    return data;
};
